export const LOADING_SELA_MESSAGE = 'Loading program modules...'
